function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var LocalStorage = /*#__PURE__*/ function() {
    "use strict";
    function LocalStorage(storageKey) {
        _class_call_check(this, LocalStorage);
        _define_property(this, "storageKey", void 0);
        this.storageKey = storageKey;
    }
    _create_class(LocalStorage, [
        {
            key: "get",
            value: function get() {
                var checkExpiry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var rawValue = localStorage.getItem(this.storageKey);
                if (!rawValue) return null;
                var value = JSON.parse(rawValue);
                if (checkExpiry && this.isExpired(value)) return null;
                return value;
            }
        },
        {
            key: "set",
            value: function set(value) {
                localStorage.setItem(this.storageKey, JSON.stringify(value));
            }
        },
        {
            key: "clear",
            value: function clear() {
                localStorage.removeItem(this.storageKey);
            }
        },
        {
            key: "isExpired",
            value: function isExpired(v) {
                if (!v || !v.expiredTime) return false;
                return new Date(v.expiredTime).getTime() < new Date().getTime();
            }
        }
    ]);
    return LocalStorage;
}();
export var SessionStorage = /*#__PURE__*/ function() {
    "use strict";
    function SessionStorage(storageKey) {
        _class_call_check(this, SessionStorage);
        _define_property(this, "storageKey", void 0);
        this.storageKey = storageKey;
    }
    _create_class(SessionStorage, [
        {
            key: "get",
            value: function get() {
                var checkExpiry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var rawValue = sessionStorage.getItem(this.storageKey);
                if (!rawValue) return null;
                var value = JSON.parse(rawValue);
                if (checkExpiry && this.isExpired(value)) return null;
                return value;
            }
        },
        {
            key: "set",
            value: function set(value) {
                sessionStorage.setItem(this.storageKey, JSON.stringify(value));
            }
        },
        {
            key: "clear",
            value: function clear() {
                sessionStorage.removeItem(this.storageKey);
            }
        },
        {
            key: "isExpired",
            value: function isExpired(v) {
                if (!v || !v.expiredTime) return false;
                return new Date(v.expiredTime).getTime() < new Date().getTime();
            }
        }
    ]);
    return SessionStorage;
}();
